import { useSelector } from 'react-redux'
import { createSlice } from '@reduxjs/toolkit'

const officeCheckDownloadsInitialState = {
  open: false,
  practices: {},
}

const officeCheckDownloadsSlice = createSlice({
  name: 'officeCheckDownloads',
  initialState: officeCheckDownloadsInitialState,
  reducers: {
    start: (state, { payload: { practiceId, fromDate, toDate } }) => {
      state.open = true
      state.practices[practiceId] = state.practices[practiceId] || {}
      const key = `${fromDate}-${toDate}`
      state.practices[practiceId][key] = state.practices[practiceId][key] || {}
      state.practices[practiceId][key].progress = 0
    },
    addProgress: (
      state,
      { payload: { practiceId, fromDate, toDate, newProgress } },
    ) => {
      const key = `${fromDate}-${toDate}`
      if (state.practices[practiceId] && state.practices[practiceId][key]) {
        state.practices[practiceId][key].progress = newProgress
      }
    },
    finish: (state, { payload: { practiceId, fromDate, toDate } }) => {
      const key = `${fromDate}-${toDate}`
      if (state.practices[practiceId] && state.practices[practiceId][key]) {
        delete state.practices[practiceId][key]
      }

      if (Object.keys(state.practices[practiceId]).length === 0) {
        delete state.practices[practiceId]
        state.open = false
      }
    },
  },
})

const { actions } = officeCheckDownloadsSlice
const selectDownloadState = state => state[officeCheckDownloadsSlice.name]

export function useOfficeCheckDownloads() {
  const { practices } = useSelector(selectDownloadState)
  return practices
}

export function initDownload(practiceId, fromDate, toDate) {
  return dispatch => {
    dispatch(actions.start({ practiceId, fromDate, toDate }))
  }
}

export function addProgress(practiceId, fromDate, toDate, newProgress) {
  return dispatch => {
    dispatch(actions.addProgress({ practiceId, fromDate, toDate, newProgress }))
  }
}

export function finish(practiceId, fromDate, toDate) {
  return dispatch => {
    dispatch(actions.finish({ practiceId, fromDate, toDate }))
  }
}

export default officeCheckDownloadsSlice
